import { render, staticRenderFns } from "./editSimplePage.vue?vue&type=template&id=2c4ddb9f"
import script from "./editSimplePage.vue?vue&type=script&lang=js"
export * from "./editSimplePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports